import {isDevEnvironment} from "./isDevEnvironment";

export const getWebsiteId = (website = window.location.hostname) => {
  const theme = localStorage.getItem("theme")?.split("-")[0] || "forth";
  let websiteId = 0;

  if (isDevEnvironment) {
    if (theme === "forth") websiteId = 1;
    if (theme === "edge" || website.includes("sportsbloodtests")) websiteId = 2;
    if (["bt", "custom"].some(t => t === theme) || website.includes("biomarkertracking")) websiteId = 3;

    return websiteId || 1;
  }

  if (
    ["localhost", "10.0.2.2", "forthwithlife.co.uk"].some(
      path => website.includes(path) && !website.includes("whitelabel"),
    )
  ) {
    return 1;
  }

  if (["forthedge.co.uk", "sportsbloodtests.co.uk"].some(path => website.includes(path))) {
    return 2;
  }

  if (["biomarkertracking.com"].some(path => website.includes(path))) {
    return 3;
  }

  if (["partnershopdev.forthwithlife.co.uk", "betashop.forthpartners.co.uk"].some(path => website.includes(path))) {
    return 4;
  }

  if (["forthpartners.co.uk"].some(path => website.includes(path))) {
    return 5;
  }

  return 3;
};
